


































































import Component from "vue-class-component";
import Vue from "vue";
import {Project} from "../model/interface/project.interface";
import {ProjectService} from "../services/project.service";
import {Collection} from "../model/interface/collection.interface";
import {GroupOrUserPrefix} from "../model/enum/groupOrUserPrefix.enum";
import {Prop, Watch} from "vue-property-decorator";
import {Observer, Subject} from "../model/interface/subject-observer.interface";
import {Client} from "../model/interface/client.interface";
import {ClientService} from "../services/client.service";

@Component
export default class ProjectHandleComponent extends Vue implements Subject {
  @Prop(Object) project!: Project;
  @Prop(Number) validationRequest!: number;
  @Prop(Object) observer!: Observer;

  private validate: boolean = false;
  private loading: boolean = false;
  private observerList: Observer[] = [];

  private maintainersList: Client[] = [];
  private acceptedMaintainersList: string[] = [];

  async mounted() {
    this.registerObserver(this.observer);
    this.project.maintainers.forEach((maintainer: Client) => {
      this.acceptedMaintainersList.push(maintainer.username);
    });
    this.maintainersList = await ClientService.loadAllUsers();
  }

  @Watch('validationRequest')
  async onValidate(validation: number) {
    await this.validateProject();
  }

  private async validateProject() {
    this.validate = true;

    //update project maintainers list according to acceptedMaintainersList
    let acceptedMaintainers: Client[] = [];
    this.acceptedMaintainersList.forEach((acceptedMaintainer: string) => {
      acceptedMaintainers.push(this.maintainersList.find(element => element.username === acceptedMaintainer));
    });
    this.project.maintainers = acceptedMaintainers;

    if (!this.validateString(this.project.alias) || !this.validateGroupOrUserID(this.project.groupOrUserId) || !this.validateGroupOrUserPrefix(this.project.groupOrUserPrefix)
    || !this.validateString(this.project.collection.key) || !this.validateString(this.project.apiKey) || !this.validateMaintainers(this.project.maintainers)) {
      return;
    }

    this.updateObservers();
  }

  //computed
  get messageClassAlias() { //more sophisticated validation possible
    return {
      'md-invalid': !this.validateString(this.project.alias) && this.validate
    };
  }
  get messageClassGroupOrUserId() {
    return {
      'md-invalid': !this.validateGroupOrUserID(this.project.groupOrUserId) && this.validate
    };
  }
  get messageClassGroupOrUserPrefix() {
    return {
      'md-invalid': !this.validateGroupOrUserPrefix(this.project.groupOrUserPrefix) && this.validate
    };
  }
  get messageClassAPIKey() {
    return {
      'md-invalid': !this.validateString(this.project.apiKey) && this.validate
    };
  }
  get messageClassCollectionId() {
    return {
      'md-invalid': !this.validateString(this.project.collection.key) && this.validate
    };
  }
  get messageClassMaintainers() {
    return {
      'md-invalid': !this.validateMaintainers(this.project.maintainers) && this.validate
    };
  }

  /**
   * Returns true, if the string is valid (no special characters, length > 2)
   * @param proposed
   */
  private validateString(proposed: string | null): boolean {
    if(!proposed)
      return false;
    return !!(proposed.length > 2 && proposed.match("^[^`~!@#$%^&*()_+={}\\[\\]|\\\\:;“’<,>.?๐฿]*$"));
  }

  /**
   * Returns true, if the string is valid (no special characters, length > 2)
   * @param proposed
   */
  private validateGroupOrUserPrefix(proposed: GroupOrUserPrefix | null): boolean {
    return !!proposed;
  }

  /**
   * Returns true, if the groupOrUserId (number) is valid
   * @param proposed
   */
  private validateGroupOrUserID(proposed: string | null): boolean {
    if(!proposed)
      return false;
    let proposedNr: number;
    try {
      proposedNr = parseInt(proposed);
    } catch (e) {
      return false;
    }
    return (proposedNr >= 0);
  }

  validateMaintainers(maintainers: Client[]): boolean {
    return maintainers.length > 0;
  }

  registerObserver(o: Observer) {
    this.observerList.push(o);
  }

  removeObserver(o: Observer) {
    if (this.observerList.indexOf(o) !== -1)
      this.observerList.splice(this.observerList.indexOf(o), 1);
  }

  updateObservers() {
    this.observerList.forEach((o: Observer) => {
      o.update(true);
    });
  }
}
